import { isNetworkingError } from "./networkingError";

export const GENERIC_ERROR_MESSAGE = "There was an error, please try again.";
const MAX_ERROR_LENGTH = 240;
// Fingerprints that suggest a server-internals error string leaked into errors[].
// We refuse to surface anything that matches these — fall back to the generic message.
const INTERNAL_FINGERPRINT = /\b(NoMethodError|PG::|ActiveRecord::|undefined method|nil:NilClass|backtrace)\b/i;

// Returns a user-safe description for a thrown mutation error.
// Only surfaces 4xx NetworkingError messages; everything else (5xx, raw throws,
// missing/oversized/internals-shaped messages) collapses to a generic string.
export function describeNetworkingError(e: unknown): string {
  if (!isNetworkingError(e)) return GENERIC_ERROR_MESSAGE;
  if (e.status < 400 || e.status >= 500) return GENERIC_ERROR_MESSAGE;
  if (!e.errors?.length) return GENERIC_ERROR_MESSAGE;

  const message = e.errors.join("\n").trim();
  if (!message) return GENERIC_ERROR_MESSAGE;
  if (message.length > MAX_ERROR_LENGTH) return GENERIC_ERROR_MESSAGE;
  if (INTERNAL_FINGERPRINT.test(message)) return GENERIC_ERROR_MESSAGE;
  return message;
}
